import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { SalesLetter } from '../components/SalesLetter';
import { BonusSection } from '../components/BonusSection';
import { TestimonialSection } from '../components/TestimonialSection';
import { PurchaseSection } from '../components/PurchaseSection';
import { PurchaseNotification } from '../components/PurchaseNotification';
export function SalesPage() {
  return <div className="min-h-screen tech-pattern text-slate-900 font-sans selection:bg-green-500 selection:text-black" data-id="element-309">
      {/* Hero con fondo de portada desenfocada */}
      <HeroSection data-id="element-310" />

      <main className="relative" data-id="element-311">
        {/* Sales Letter con bloques alternados */}
        <SalesLetter data-id="element-312" />

        {/* Bonuses */}
        <BonusSection data-id="element-313" />

        {/* Testimonials */}
        <TestimonialSection data-id="element-314" />

        {/* Purchase */}
        <PurchaseSection data-id="element-315" />
      </main>

      <footer className="bg-black/95 py-12 text-center text-slate-500 text-sm border-t border-green-500/20" data-id="element-316">
        <div className="max-w-4xl mx-auto px-4" data-id="element-317">
          <p className="mb-4" data-id="element-318">© 2025 Todos los derechos reservados.</p>
          <p data-id="element-319">
            Este producto no garantiza la obtención de resultados. Las
            referencias al desempeño de una determinada estrategia no debe ser
            interpretada como una garantía de resultados.
          </p>
        </div>
      </footer>

      <PurchaseNotification data-id="element-320" />
    </div>;
}